export const EVesDataColumns = {
	eventTime: { title: 'Event Time', key: 'eventTime' },
	fileName: { title: 'PM File', key: 'fileName' },
	id: { title: 'ID', key: 'id' },
	middlewareName: { title: 'Middleware', key: 'middlewareName' },
	networkElementName: { title: 'Network Element', key: 'networkElementName' },
	sequence: { title: 'Sequence', key: 'sequence' },
	source: { title: 'Source', key: 'source' },
};

export interface IVesData {
	eventTime: number;
	fileName: string;
	id: string;
	middlewareName: string;
	networkElementName: string;
	sequence: number;
	source: string;
}
